export class FHLog {
    constructor() {
        this.log = (...args) => {
            console.log('FeatureHub/Log: ', ...args);
        };
        this.error = (...args) => {
            console.error('FeatureHub/Error: ', ...args);
        };
        this.trace = (...args) => {
        };
    }
    quiet() {
        FHLog.fhLog.log = () => {
        };
        FHLog.fhLog.error = () => {
        };
        FHLog.fhLog.trace = () => {
        };
    }
}
FHLog.fhLog = new FHLog();
export const fhLog = FHLog.fhLog;
//# sourceMappingURL=feature_hub_config.js.map